import { useContext } from 'react';

import { AlertContextType } from '../contexts/AlertContext/alert-context.type';
import { AlertContext } from '../contexts/AlertContext/AlertContext';

const useAlert = () => {
  const context = useContext<AlertContextType | undefined>(AlertContext);

  if (!context) {
    throw new Error(
      'AlertProvider context is undefined, please verify you are calling useAlert() as child of a <AlertProvider> component.',
    );
  }

  return context;
};

export default useAlert;
